import { styled } from '@mui/material';

export const CardStyled = styled('div')(({ theme }) => ({
  heght: '100%',
  height: theme.spacings.unit(99.5),
  borderRadius: theme.borders.roundness,
  backgroundColor: `${theme.colors.background} !important`,
  color: theme.colors.primaryText,
  display: 'flex',
  flexDirection: 'column',
  '&:hover': {
    cursor: 'pointer',
    boxShadow: theme.gradients.card,
  },
}));

export const CardDescriptionContainer = styled('div')(({ theme }) => ({
  padding: `
      ${theme.spacings.unit(4)} 
      ${theme.spacings.unit(3)}
    `,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacings.unit(2),
}));

export const TypeFieldText = styled('span')(({ theme }) => ({
  fontSize: theme.fonts.utility.size(7),
  fontWeight: theme.fonts.default.bold.fontWeight,
  color: theme.colors.secondary,
  lineHeight: theme.spacings.unit(7),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const TitleFieldText = styled('p')(({ theme }) => ({
  fontSize: theme.fonts.utility.size(9),
  fontWeight: theme.fonts.default.medium.fontWeight,
  color: theme.colors.primaryText,
  width: 'calc(100%)',
  display: '-webkit-box',
  '-webkit-line-clamp': '2',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
  margin: '0',
}));

export const DescriptionFieldText = styled('p')(() => ({
  width: 'calc(100%)',
  display: '-webkit-box',
  '-webkit-line-clamp': '3',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
  margin: '0',
}));

export const ImageContainer = styled('div')<{
  $hasImage: boolean;
}>(({ theme, $hasImage }) => ({
  display: 'flex',
  height: theme.spacings.unit(54),
  maxHeight: theme.spacings.unit(54),
  justifyContent: 'center',
  borderRadius: theme.borders.roundness,
  overflow: 'hidden',
  alignSelf: $hasImage ? 'auto' : 'center',
}));

export const ImageStyled = styled('img')<{ $hasImage: boolean }>(
  ({ theme, $hasImage }) => ({
    overflow: 'hidden',
    mixBlendMode: 'multiply',
    objectFit: 'cover',
    objectPosition: 'center center',
    borderRadius: theme.borders.roundness,
    scale: $hasImage ? '1' : '0.5',
    width: $hasImage ? '100%' : 'auto',
  })
);
